import { Injectable, Inject } from '@angular/core';
import { ENV_CONFIG } from 'src/app/core/injection.token';
import { ApiService } from 'src/app/core/services/api.service';

@Injectable()
export class TenantAPIService {
  public constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  private readonly controller = 'tenant';

  public GetTenantTheme() {
    const request = 'getTenantTheme';
    const url = this._apiService.buildUrl(this._envConfig.TENANT_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.get<app.models.Theme>(url);
  }

  public getTenantTranslation(languageCode: string, languageId: string | null = null) {
    const request = 'getTenantTranslation';
    const url = this._apiService.buildUrl(this._envConfig.TENANT_BACKEND_APISYNC_URL, this.controller, request);
    const data = { languageCode: languageCode, languageId: languageId };

    return this._apiService.get<app.models.TenantTranslation>(url, data);
  }

  public getUserProfile() {
    const request = 'getUserProfile';
    const url = this._apiService.buildUrl(
      this._envConfig.TENANT_BACKEND_APISYNC_URL.replace('/tap', ''),
      'User',
      request,
      {}
    );
    const data = { skipException: true, serviceCode: this._envConfig.SERVICE_CODE };

    return this._apiService.get<app.models.UserProfileModel>(url, data);
  }

  public getExternalProviders(roleCode: string) {
    const request = 'getExternalProviders';
    const url = this._apiService.buildUrl(this._envConfig.TENANT_BACKEND_APISYNC_URL, this.controller, request);
    const data = { roleCode: roleCode };

    return this._apiService.get<app.models.DictionaryDataModel[]>(url, data);
  }

  public SaveTenantTheme(data: string) {
    const request = 'saveTenantTheme';
    const url = this._apiService.buildUrl(this._envConfig.TENANT_BACKEND_APISYNC_URL, this.controller, request);

    return this._apiService.postAsync<any>(url, { data: data }, []);
  }

  public getLocaleValidators() {
    const request = 'getLocaleValidators';
    const url = this._apiService.buildUrl(
      this._envConfig.TENANT_BACKEND_APISYNC_URL.replace('/tap', ''),
      this.controller,
      request
    );

    return this._apiService.get<app.models.Validator[]>(url);
  }

  public hasTenantTwoFactorAuthentication() {
    const request = 'hasTenantTwoFactorAuthentication';
    const url = this._apiService.buildUrl(
      this._envConfig.TENANT_BACKEND_APISYNC_URL.replace('/tap', ''),
      this.controller,
      request
    );

    return this._apiService.get<boolean>(url);
  }

  public getTenantId() {
    const request = 'getTenantId';
    const url = this._apiService.buildUrl(
      this._envConfig.TENANT_BACKEND_APISYNC_URL.replace('/tap', ''),
      this.controller,
      request
    );

    return this._apiService.getRaw(url);
  }
}
